import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    Container,
    Row,
    Col,
    Card,
    Badge,
} from "react-bootstrap";

const BASE = (() => {
    let url = process.env.REACT_APP_API_URL || "https://proudtapi.onrender.com";
    url = url.replace(/\/$/, "");
    if (url.endsWith("/api")) url = url.slice(0, -4);
    return url;
})();

const CATEGORY_API = `${BASE}/api/news/categories`;

const CategoriesPage = () => {
    const [categories, setCategories] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const res = await fetch(CATEGORY_API);
            const result = await res.json();
            const categoriesData = result?.categories || result?.data || [];
            setCategories(Array.isArray(categoriesData) ? categoriesData : []);
        } catch (err) {
            setError("Unable to load categories. Please try again.");
            console.error("Fetch categories error:", err);
        }
    };

    // Group categories by group
    const groupedCategories = categories.reduce((acc, cat) => {
        const group = cat.group || "General";
        if (!acc[group]) acc[group] = [];
        acc[group].push(cat);
        return acc;
    }, {});

    if (error) {
        return (
            <Container className="py-4">
                <div className="text-center">
                    <p className="text-danger">{error}</p>
                    <button className="btn btn-primary" onClick={fetchCategories}>Retry</button>
                </div>
            </Container>
        );
    }

    return (
        <Container className="py-4">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <h2 className="mb-1">All Categories</h2>
                    <p className="text-muted">Browse news by category.</p>
                </div>
                <Link to="/" className="btn btn-outline-secondary">
                    Back to Home
                </Link>
            </div>

            {Object.keys(groupedCategories).map((group) => (
                <div key={group} className="mb-5">
                    <h4 className="mb-3">
                        <Badge bg="primary" className="me-2">{group}</Badge>
                    </h4>
                    <Row className="g-3">
                        {groupedCategories[group].map((cat, i) => (
                            <Col md={3} sm={6} key={i}>
                                <Card className="shadow-sm h-100 card-hover text-center">
                                    <Card.Body className="d-flex align-items-center justify-content-center">
                                        <Link to={`/category/${encodeURIComponent(cat.name)}`} className="text-decoration-none">
                                            <div>
                                                <h6 className="mb-1">{cat.name}</h6>
                                                <small className="text-muted">{cat.group}</small>
                                            </div>
                                        </Link>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            ))}
        </Container>
    );
};

export default CategoriesPage;